export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5279.36359d8e.jpg";